import { Card, CardContent, CardHeader, CardTitle } from "@/components/card";
import { ChartContainer, ChartTooltip, ChartTooltipContent } from "@/components/chart";
import type { JiraMetricsSLAFunnelPoint } from "@/http/api-types";
import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from "recharts";

export function SlaFunnelChart({ data }: { data: JiraMetricsSLAFunnelPoint[] }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>SLA Funnel</CardTitle>
      </CardHeader>
      <CardContent>
        <ChartContainer className="h-72 w-full" config={{ count: { label: "Tickets", color: "#3b82f6" } }}>
          <BarChart data={data}>
            <CartesianGrid vertical={false} />
            <XAxis dataKey="stage" />
            <YAxis />
            <ChartTooltip content={<ChartTooltipContent />} />
            <Bar dataKey="count" fill="var(--color-count)" />
          </BarChart>
        </ChartContainer>
      </CardContent>
    </Card>
  );
}
